import Image from 'next/image';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

import onboardingIntroSkyCloudDriftImage from '~/assets/onboarding-intro/cloud-drift.webp';
import styles from '~/components/v2/components/workspace/onboarding-intro/sky/onboardingIntroSkyClouds.module.css';

export type OnboardingIntroSkyCloudProps = {
  morphOverlayClassName: string;
  shouldReduceMotion: boolean;
  swellClassName: string;
};

export const OnboardingIntroSkyCloud = memo(
  ({ morphOverlayClassName, shouldReduceMotion, swellClassName }: OnboardingIntroSkyCloudProps) => (
    <div className="relative size-full">
      <Image
        alt=""
        className={cn(
          'pointer-events-none h-full w-full max-w-none select-none object-contain',
          styles.skyCloudNight,
          !shouldReduceMotion && swellClassName,
        )}
        height={onboardingIntroSkyCloudDriftImage.height}
        src={onboardingIntroSkyCloudDriftImage}
        width={onboardingIntroSkyCloudDriftImage.width}
      />
      {shouldReduceMotion ? null : (
        <Image
          alt=""
          className={cn(
            'pointer-events-none absolute inset-0 h-full w-full max-w-none select-none object-contain',
            styles.skyCloudNight,
            morphOverlayClassName,
          )}
          height={onboardingIntroSkyCloudDriftImage.height}
          src={onboardingIntroSkyCloudDriftImage}
          width={onboardingIntroSkyCloudDriftImage.width}
        />
      )}
    </div>
  ),
);

OnboardingIntroSkyCloud.displayName = 'OnboardingIntroSkyCloud';
